/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import userApi from 'api/user.api';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';

/* Thunks */
export const getUsersBy = createFOAsyncThunk('getUsers/getUsersBy', async (args) => {
  return userApi.getUsersBySearch(args.searchString, args.extraParams);
});
